import clsx from 'clsx';
import {
  type PropsWithChildren,
  type CSSProperties,
  type ElementType,
  type ComponentPropsWithoutRef,
} from 'react';
import { defaultTags, variantClasses } from './constants';
import { type TypographyVariant } from './types';

export type TypographyProps<T extends ElementType> = PropsWithChildren<{
  variant?: TypographyVariant;
  className?: string;
  style?: CSSProperties;
  as?: T;
}> &
  Omit<ComponentPropsWithoutRef<T>, 'style' | 'color' | 'className'>;

export function Typography<T extends ElementType = 'span'>({
  variant = 'text-medium',
  className = '',
  style,
  as,
  children,
  ...props
}: TypographyProps<T>) {
  const Component = as || defaultTags[variant];
  const variantClass = variantClasses[variant];
  const additionalClass = Component === 'span' ? 'block' : '';

  return (
    <Component className={clsx(variantClass, additionalClass, className)} style={style} {...props}>
      {children}
    </Component>
  );
}
